import React from 'react';

// components
import BaseApi from "../../utils/BaseApi";
import withRouter from "../../utils/withRouter";
import {
    Card,
    CardContent,
    CircularProgress,
    Stack,
    Typography
} from "@mui/joy";

// components
import withNavigate from "../../utils/withNavigate";


// icons
import Checklist from "../Checklist/Checklist";


class OpportunityDetail extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            opportunity: null,
            checklists: null
        };
    }

    async componentDidMount() {
        await this.retrieveOpportunity();
    }

    async componentDidUpdate(prevProps, prevState, snapshot){
        if (prevProps !== this.props){
            await this.retrieveOpportunity();
        }
    }

    async retrieveOpportunity(){
        this.setState(
            {
                opportunity: null,
                checklists: null
            }
        );
        let url = `opportunity/${this.props.params.opportunityId}/`;
        let params = {};
        const api = new BaseApi();
        let response = await api.get(
            url,
            params
        );
        let opportunity = response.data
        if (response.status === 200){
            url = `checklist/`;
            params = {
                entity: 'MarketingOpportunity',
                entity_id: opportunity.id
            };
            const api = new BaseApi();
            response = await api.get(
                url,
                params
            );
            this.setState(
            {
                    opportunity: opportunity,
                    checklists: response.data.results,
                }
            );
        }
    }

    render() {
        if (!this.state.opportunity || !this.state.checklists){
            return(
                <CircularProgress/>
            )
        }
        return(
            <Stack
                spacing={2}
            >
                <Card>
                    <CardContent>
                        <Typography
                            level="h3"
                            sx={{
                                pb: 2,
                                pt: 2,
                            }}
                        >
                            {this.state.opportunity.title}
                        </Typography>
                        <Stack
                            spacing={2}
                        >
                            {
                                this.state.checklists.map((each) => (
                                    <Checklist
                                        checklist={each}
                                    />
                                ))
                            }
                        </Stack>
                    </CardContent>
                </Card>
            </Stack>
        )
    }
}

export default withNavigate(withRouter(OpportunityDetail));
